import React, { memo } from 'react';
import { ListItem } from 'appkit-react';
import PropTypes from 'prop-types';

import { insightModals } from '@model';

function AnalysisInsightListCard({ sequence, data = {}, onClick }) {
  const { title, summary } = data;
  const goToDetail = () => {
    onClick({
      type: insightModals.INSIGHT_DETAIL,
      currentDetail: data,
    });
  };
  return (
    <ListItem>
      <span
        className="appkiticon icon-arrow-right-outline"
        onClick={goToDetail}
      />
      <div className="list-title">
        <span className="sequence-label">{sequence}</span>
        {title || '-'}
      </div>
      <div className="list-content">{summary || '-'}</div>
    </ListItem>
  );
}

AnalysisInsightListCard.propTypes = {
  data: PropTypes.object.isRequired,
  sequence: PropTypes.number.isRequired,
};

export default memo(AnalysisInsightListCard);
